import React, { useMemo } from 'react';
import OrgTree from '../OrgTree/OrgTree';
import RubricTeamNode from './RubricTeamNode';
import { rubricTeamsSchemeById } from 'js/utils/rubric-org-scores';

const RubricOrgTree = ({
  parentWidth,
  rubricId,
  rubricTeams,
  rubricDocument,
  teamNameBuffer = 200,
  ...orgTreeProps
}) => {
  const teamSchemeById = useMemo(
    () => rubricTeamsSchemeById(rubricTeams, rubricDocument),
    [rubricTeams, rubricDocument]
  );

  const targetLeafHeight = useMemo(() => {
    if (rubricTeams.some((t) => t.scheme_applied != null)) {
      return (showWeights) => {
        if (showWeights) {
          return 32;
        }
        return 25;
      };
    }
    return 25;
  }, [rubricTeams]);

  return (
    <OrgTree
      width={parentWidth}
      {...orgTreeProps}
      targetLeafHeight={targetLeafHeight}
      assessmentKey={rubricId}
      teamNameBuffer={teamNameBuffer}
      nodeComponents={{ Team: RubricTeamNode }}
      teamNodeProps={{ rubricId, teamSchemeById }}
    />
  );
};

export default RubricOrgTree;
